import { IAppState, TActions } from '../../../common/state';
import { EEntranceType, jq } from '../../../json_query';

import { getParamChangedAction } from './fabrics/multiselect_param_reducer';

type TEntranceTypeChangedActionType = 'filters/entrance/ENTRANCE_TYPE_CHANGED';
export const IEntranceTypeChangedActionType =
  'filters/entrance/ENTRANCE_TYPE_CHANGED' as TEntranceTypeChangedActionType;

export interface IEntranceTypeChangedAction {
  type: 'filters/entrance/ENTRANCE_TYPE_CHANGED';
  paramType: EEntranceType;
  value: boolean;
}

export const changeEntrance = getParamChangedAction<EEntranceType, TEntranceTypeChangedActionType>(
  IEntranceTypeChangedActionType,
);

export function entranceTypeReducer(state: IAppState, action: TActions): IAppState {
  switch (action.type) {
    case IEntranceTypeChangedActionType:
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: action.value
            ? jq(state.filters.jsonQuery).setEntranceType(action.paramType)
            : jq(state.filters.jsonQuery).unsetEntranceType(action.paramType),
        },
      };

    case 'filters/tags/TAG_REMOVED':
      if (action.tag.type === 'advanced-entrance') {
        return {
          ...state,
          filters: {
            ...state.filters,
            jsonQuery: jq(state.filters.jsonQuery).unsetEntranceType(action.tag.value),
          },
        };
      }

      return state;

    case 'filters/tags/ALL_TAGS_REMOVED':
      return {
        ...state,
        filters: {
          ...state.filters,
          jsonQuery: jq(state.filters.jsonQuery).unsetEntranceTypes(),
        },
      };

    default:
      return state;
  }
}
